export type PaymentRequiredMessageKey =
  | 'paymentRequired'
  | 'paymentRequiredNoBilling'
  | 'paymentRequiredElama';

/**
 * Кабинеты eLama оплачиваются через eLama: пополнение баланса SmartbotPro не снимает блокировку,
 * поэтому для них используется отдельное сообщение вместо подсказки о пополнении.
 */
export const getPaymentRequiredMessageKey = ({
  isELamaUser,
  canViewBilling
}: {
  isELamaUser: boolean;
  canViewBilling: boolean;
}): PaymentRequiredMessageKey => {
  if (isELamaUser) {
    return 'paymentRequiredElama';
  }

  if (canViewBilling) {
    return 'paymentRequired';
  }

  return 'paymentRequiredNoBilling';
};
